import { IdentifyParams, TrackParams } from "@segment/analytics-node";

import { CURRENT_COUNTRY } from "src/constants/Countries";

import { trackSegment } from ".";

export const identify$ = async (param: IdentifyParams) => {
  await trackSegment({
    ...param,
    segmentType: "identify"
  });
};

export const track$ = async (param: TrackParams) => {
  param.properties = param.properties || {};
  param.properties.region = CURRENT_COUNTRY;
  await trackSegment({
    ...param,
    segmentType: "track"
  });
};
